import { PackageProps } from "modules/membership_plan/commercial_membership_plan/packages/store/actionType";
import { VideoCategoryProps } from "modules/video/category/store/actionType";
import { VideoEpisodeProps } from "modules/video/episode/store/actionType";
import { v4 as UUID } from "uuid";

export enum actionTypes {
  FETCH_VIDEO_DETAIL_REQUEST = "FETCH_VIDEO_DETAIL_REQUEST",
  FETCH_VIDEO_DETAIL_SUCCESS = "FETCH_VIDEO_DETAIL_SUCCESS",
  FETCH_VIDEO_DETAIL_FAIL = "FETCH_VIDEO_DETAIL_FAIL",
  //fetch vido view count
  FETCH_VIDEO_VIEW_COUNT_REQUEST = "FETCH_VIDEO_VIEW_COUNT_REQUEST",
  FETCH_VIDEO_VIEW_COUNT_SUCCESS = "FETCH_VIDEO_VIEW_COUNT_SUCCESS",
  FETCH_VIDEO_VIEW_COUNT_FAIL = "FETCH_VIDEO_VIEW_COUNT_FAIL",
  //fetch package by ref id
  FETCH_PACKAGE_BY_REF_ID_REQUEST = "FETCH_PACKAGE_BY_REF_ID_REQUEST",
  FETCH_PACKAGE_BY_REF_ID_SUCCESS = "FETCH_PACKAGE_BY_REF_ID_SUCCESS",
  FETCH_PACKAGE_BY_REF_ID_FAIL = "FETCH_PACKAGE_BY_REF_ID_FAIL",
  // create video
  CREATE_VIDEO_DETAIL_REQUEST = "CREATE_VIDEO_DETAIL_REQUEST",
  CREATE_VIDEO_DETAIL_SUCCESS = "CREATE_VIDEO_DETAIL_SUCCESS",
  CREATE_VIDEO_DETAIL_FAIL = "CREATE_VIDEO_DETAIL_FAIL",
  // update video
  UPDATE_VIDEO_DETAIL_REQUEST = "UPDATE_VIDEO_DETAIL_REQUEST",
  UPDATE_VIDEO_DETAIL_SUCCESS = "UPDATE_VIDEO_DETAIL_SUCCESS",
  UPDATE_VIDEO_DETAIL_FAIL = "UPDATE_VIDEO_DETAIL_FAIL",
  //delete video
  DELETE_VIDEO_DETAIL_REQUEST = "DELETE_VIDEO_DETAIL_REQUEST",
  DELETE_VIDEO_DETAIL_SUCCESS = "DELETE_VIDEO_DETAIL_SUCCESS",
  DELETE_VIDEO_DETAIL_FAIL = "DELETE_VIDEO_DETAIL_FAIL",
  //reset
  RESET_VIDEO = "RESET_VIDEO",
  //UploadVideo
  UPLOAD_VIDEO_REQUEST = "UPLOAD_VIDEO_REQUEST",
  UPLOAD_VIDEO_SUCCESS = "UPLOAD_VIDEO_SUCCESS",
  UPLOAD_VIDEO_FAIL = "UPLOAD_VIDEO_FAIL",
  //video visibility
  UPDATE_VIDEO_VISIBILITY_REQUEST = "UPDATE_VIDEO_VISIBILITY_REQUEST",
  UPDATE_VIDEO_VISIBILITY_SUCCESS = "UPDATE_VIDEO_VISIBILITY_SUCCESS",
  UPDATE_VIDEO_VISIBILITY_FAIL = "UPDATE_VIDEO_VISIBILITY_FAIL",
  //video featured
  UPDATE_VIDEO_FEATURED_REQUEST = "UPDATE_VIDEO_FEATURED_REQUEST",
  UPDATE_VIDEO_FEATURED_SUCCESS = "UPDATE_VIDEO_FEATURED_SUCCESS",
  UPDATE_VIDEO_FEATURED_FAIL = "UPDATE_VIDEO_FEATURED_FAIL",
  //check video status
  CHECK_VIDEO_STATUS_REQUEST = "CHECK_VIDEO_STATUS_REQUEST",
  CHECK_VIDEO_STATUS_SUCCESS = "CHECK_VIDEO_STATUS_SUCCESS",
  CHECK_VIDEO_STATUS_FAIL = "CHECK_VIDEO_STATUS_FAIL",
  //add package to video
  ADD_PACKAGE_TO_VIDEO_REQUEST = "ADD_PACKAGE_TO_VIDEO_REQUEST",
  ADD_PACKAGE_TO_VIDEO_SUCCESS = "ADD_PACKAGE_TO_VIDEO_SUCCESS",
  ADD_PACKAGE_TO_VIDEO_FAIL = "ADD_PACKAGE_TO_VIDEO_FAIL",

  SET_VIDEO_TO_ANOTHER_GROUP_REQUEST = "SET_VIDEO_TO_ANOTHER_GROUP_REQUEST",
  SET_VIDEO_TO_ANOTHER_GROUP_SUCCESS = "SET_VIDEO_TO_ANOTHER_GROUP_SUCCESS",
  SET_VIDEO_TO_ANOTHER_GROUP_FAIL = "SET_VIDEO_TO_ANOTHER_GROUP_FAIL",
}

export interface GenericVideoDetailStateProps {
  isLoading: boolean;
  status: stateStatusType | string;
  error: string | null;
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface UpdateSingleDataInput {
  field: string;
  value: string;
  video_id: string;
}

export interface fetchPackageByRefIdInput {
  content_type: string;
  ref_id: string;
}
export interface AddPackageInput {
  package_ids: string[];
  content_type: string;
  ref_id: string;
}
export interface AddPackageInputError {
  package_ids?: string;
  content_type?: string;
}
export interface CreateVideoInput {
  thumbnail?: string;
  category_id?: string;
  episode_id?: string;
  title: string;
  season_folder_id?: string;
  package_id?: string;
}
export interface CreateVideoError {
  title?: string;
  video?: string;
}
export interface UploadVideoInput {
  title: string;
  folder_id: string;
  create_video_id: string;
}
export interface Packages {
  updated_at:string
  id:string
  package_id:string
  content_type:string
  ref_id:string
  created_at:string
  package:PackageProps
}

export interface VideoDetailProps {
  identifier: string;
  visibility: string;
  otp: string;
  id: typeof UUID;
  playback_info: string;
  featured: string;
  title: string;
  video: string;
  classification_id: string;
  category: VideoCategoryProps;
  episode: VideoEpisodeProps;
  season_folder_id: string;
  upload_status: string;
  thumbnail: string;
  packages?: Packages[];
}
export interface ClientPayloadProps {
  key: string;
  policy: string;
  uploadLink: string;
  video_id: string;
  x_amz_algorithm: string;
  x_amz_credential: string;
  x_amz_date: string;
  x_amz_signature: string;
}

export interface VideoProps {
  video: VideoDetailProps;
  clientPayload: ClientPayloadProps;
}
export interface VideoViewCountProps {
  count: string;
  created_at: string;
  id: string;
  updated_at: string;
  user_id: string;
  video_id: string;
}

export interface SetVideoToAnotherGroupInput {
  category_id?: string;
  episode_id?: string;
  season_folder_id?: string;
  title?: string;
  group_id?: string;
  series_id?: string;
  season_id?: string;
}
export interface SetVideoToAnotherGroupError {
  category_id?: string;
  episode_id?: string;
  season_folder_id?: string;
  title?: string;
  group_id?: string;
  series_id?: string;
  season_id?: string;
}
export interface SetVideoToAnotherGroupError {
  category_id?: string;
  episode_id?: string;
  season_folder_id?: string;
  title?: string;
  group_id?: string;
  series_id?: string;
  season_id?: string;
}

//FetchVideoDetail
export interface FetchVideoDetailsRequestAction {
  type: actionTypes.FETCH_VIDEO_DETAIL_REQUEST;
}

export interface FetchVideoDetailsSuccessAction {
  type: actionTypes.FETCH_VIDEO_DETAIL_SUCCESS;
  payload: VideoProps;
}

export interface FetchVideoDetailsFailureAction {
  type: actionTypes.FETCH_VIDEO_DETAIL_FAIL;
  payload: string;
}
//FetchVideoView
export interface FetchVideoViewCountRequestAction {
  type: actionTypes.FETCH_VIDEO_VIEW_COUNT_REQUEST;
}

export interface FetchVideoViewCountSuccessAction {
  type: actionTypes.FETCH_VIDEO_VIEW_COUNT_SUCCESS;
  payload: VideoViewCountProps[];
}

export interface FetchVideoViewCountFailureAction {
  type: actionTypes.FETCH_VIDEO_VIEW_COUNT_FAIL;
  payload: string;
}

//CreateVideoDetail`
export interface CreateVideoDetailRequestAction {
  type: actionTypes.CREATE_VIDEO_DETAIL_REQUEST;
}
export interface CreateVideoDetailSuccessAction {
  type: actionTypes.CREATE_VIDEO_DETAIL_SUCCESS;
  payload: VideoProps;
}
export interface CreateVideoDetailFailAction {
  type: actionTypes.CREATE_VIDEO_DETAIL_FAIL;
  payload: string;
}

//UpdateVideoDetail
export interface UpdateVideoDetailRequestAction {
  type: actionTypes.UPDATE_VIDEO_DETAIL_REQUEST;
}
export interface UpdateVideoDetailSuccessAction {
  type: actionTypes.UPDATE_VIDEO_DETAIL_SUCCESS;
  payload: VideoDetailProps;
}
export interface UpdateVideoDetailFailAction {
  type: actionTypes.UPDATE_VIDEO_DETAIL_FAIL;
  payload: string;
}

//DeleteVideoDetail
export interface DeleteVideoDetailRequestAction {
  type: actionTypes.DELETE_VIDEO_DETAIL_REQUEST;
}
export interface DeleteVideoDetailSuccessAction {
  type: actionTypes.DELETE_VIDEO_DETAIL_SUCCESS;
  payload: string;
}
export interface DeleteVideoDetailFailAction {
  type: actionTypes.DELETE_VIDEO_DETAIL_FAIL;
  payload: string;
}

//RESET
export interface ResetVideo {
  type: actionTypes.RESET_VIDEO;
}

//Upload video
export interface UploadVideoRequestAction {
  type: actionTypes.UPLOAD_VIDEO_REQUEST;
}
export interface UploadVideoSuccessAction {
  type: actionTypes.UPLOAD_VIDEO_SUCCESS;
  payload: ClientPayloadProps;
}
export interface UploadVideoFailAction {
  type: actionTypes.UPLOAD_VIDEO_FAIL;
  payload: string;
}
// video VISIBILITY
export interface UpdateVideoVisibilityRequestAction {
  type: actionTypes.UPDATE_VIDEO_VISIBILITY_REQUEST;
}
export interface UpdateVideoVisibilitySuccessAction {
  type: actionTypes.UPDATE_VIDEO_VISIBILITY_SUCCESS;
  payload: VideoProps;
}
export interface UpdateVideoVisibilityFailAction {
  type: actionTypes.UPDATE_VIDEO_VISIBILITY_FAIL;
  payload: string;
}
// video FEATURED
export interface UpdateVideoFeaturedRequestAction {
  type: actionTypes.UPDATE_VIDEO_FEATURED_REQUEST;
}
export interface UpdateVideoFeaturedSuccessAction {
  type: actionTypes.UPDATE_VIDEO_FEATURED_SUCCESS;
  payload: VideoProps;
}
export interface UpdateVideoFeaturedFailAction {
  type: actionTypes.UPDATE_VIDEO_FEATURED_FAIL;
  payload: string;
}
// fetch package by ref id
export interface FetchPackageByRefIdRequestAction {
  type: actionTypes.FETCH_PACKAGE_BY_REF_ID_REQUEST;
}
export interface FetchPackageByRefIdSuccessAction {
  type: actionTypes.FETCH_PACKAGE_BY_REF_ID_SUCCESS;
  payload: Packages[];
}
export interface FetchPackageByRefIdFailAction {
  type: actionTypes.FETCH_PACKAGE_BY_REF_ID_FAIL;
  payload: string;
}
// add package to video
export interface AddPackageToVideoRequestAction {
  type: actionTypes.ADD_PACKAGE_TO_VIDEO_REQUEST;
}
export interface AddPackageToVideoSuccessAction {
  type: actionTypes.ADD_PACKAGE_TO_VIDEO_SUCCESS;
  payload: Packages[];
}
export interface AddPackageToVideoFailAction {
  type: actionTypes.ADD_PACKAGE_TO_VIDEO_FAIL;
  payload: string;
}
export interface SetVideoToAnotherGroupRequestAction {
  type: actionTypes.SET_VIDEO_TO_ANOTHER_GROUP_REQUEST;
}
export interface SetVideoToAnotherGroupSuccessAction {
  type: actionTypes.SET_VIDEO_TO_ANOTHER_GROUP_SUCCESS;
}
export interface SetVideoToAnotherGroupFailAction {
  type: actionTypes.SET_VIDEO_TO_ANOTHER_GROUP_FAIL;
  payload: string;
}

export type VideoDetailActions =
  | FetchVideoDetailsRequestAction
  | FetchVideoDetailsSuccessAction
  | FetchVideoDetailsFailureAction
  | FetchVideoViewCountRequestAction
  | FetchVideoViewCountSuccessAction
  | FetchVideoViewCountFailureAction
  | CreateVideoDetailRequestAction
  | CreateVideoDetailSuccessAction
  | CreateVideoDetailFailAction
  | UpdateVideoDetailRequestAction
  | UpdateVideoDetailSuccessAction
  | UpdateVideoDetailFailAction
  | DeleteVideoDetailRequestAction
  | DeleteVideoDetailSuccessAction
  | DeleteVideoDetailFailAction
  | ResetVideo
  | UploadVideoRequestAction
  | UploadVideoSuccessAction
  | UploadVideoFailAction
  | UpdateVideoVisibilityRequestAction
  | UpdateVideoVisibilitySuccessAction
  | UpdateVideoVisibilityFailAction
  | UpdateVideoFeaturedRequestAction
  | UpdateVideoFeaturedSuccessAction
  | UpdateVideoFeaturedFailAction
  | AddPackageToVideoRequestAction
  | AddPackageToVideoSuccessAction
  | AddPackageToVideoFailAction
  | FetchPackageByRefIdRequestAction
  | FetchPackageByRefIdSuccessAction
  | FetchPackageByRefIdFailAction
  | SetVideoToAnotherGroupRequestAction
  | SetVideoToAnotherGroupSuccessAction
  | SetVideoToAnotherGroupFailAction;
